module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "header-logo"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, [_c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    class: {
      'active': _vm.module == 'home'
    },
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.goMain
    }
  }, [_c('span', {
    staticClass: "nav-icon"
  }, [_vm._v("主页")])])]), _vm._v(" "), _vm._l((_vm.navData), function(item) {
    return _c('li', {
      staticClass: "nav-list-item"
    }, [_c('a', {
      class: {
        'active': _vm.module == item.module
      },
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('span', {
      staticClass: "nav-icon"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (item.sub) ? _c('div', {
      staticClass: "nav-list-sub-item"
    }, _vm._l((item.sub), function(sub) {
      return _c('router-link', {
        key: sub.id,
        attrs: {
          "to": sub.link
        },
        nativeOn: {
          "click": function($event) {
            _vm.setModule(item.module, item.text, sub.text)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(sub.text) + "\n\t\t\t\t\t\t")])
    })) : _vm._e()])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17a7300c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/navbar.vue
// module id = 119
// module chunks = 1